import React from 'react';
import { Box, Typography, Paper, Divider } from '@mui/material';
import EqualizerRounded from '@mui/icons-material/EqualizerRounded';

// ─── Stats adapter ────────────────────────────────────────────────────────────

export function adaptStats(topStats) {
  return topStats.map(stat => {
    const v = stat.value;
    if (v.percentage) return { label: stat.name, home: v.percentage.home, away: v.percentage.away, unit: '%' };
    if (v.float)      return { label: stat.name, home: v.float.home,       away: v.float.away,       unit: '' };
    if (v.integer)    return { label: stat.name, home: v.integer.home,     away: v.integer.away,     unit: '' };
    return { label: stat.name, home: 0, away: 0, unit: '' };
  });
}

function StatBar({ stat, homeColor, awayColor }) {
  const home = Number(stat.home);
  const away = Number(stat.away);
  const total = home + away;
  // Each bar's width = value / total, expressed as % of the full track.
  // Bars grow outward from the fixed centre (50%). overflow:hidden clips any
  // bar that would exceed its side (e.g. when one team's share > 50%).
  const homePct = total === 0 ? 50 : (home / total) * 100;
  const awayPct = total === 0 ? 50 : (away / total) * 100;

  return (
    <Box sx={{ mb: 1.5 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
        <Typography variant="body2" sx={{ fontWeight: 600, minWidth: 40 }}>{stat.home}{stat.unit}</Typography>
        <Typography variant="caption" sx={{ color: 'text.secondary', textAlign: 'center', flex: 1 }}>{stat.label}</Typography>
        <Typography variant="body2" sx={{ fontWeight: 600, minWidth: 40, textAlign: 'right' }}>{stat.away}{stat.unit}</Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: '6px' }}>
        {/* Home track — bar is right-aligned so it grows outward from the centre gap */}
        <Box sx={{ flex: 1, height: 10, borderRadius: 5, bgcolor: 'rgba(255,255,255,0.1)', display: 'flex', justifyContent: 'flex-end', overflow: 'hidden' }}>
          <Box sx={{ width: `${homePct}%`, height: '100%', bgcolor: homeColor, borderRadius: 3 }} />
        </Box>
        {/* Away track — bar is left-aligned so it grows outward from the centre gap */}
        <Box sx={{ flex: 1, height: 10, borderRadius: 5, bgcolor: 'rgba(255,255,255,0.1)', overflow: 'hidden' }}>
          <Box sx={{ width: `${awayPct}%`, height: '100%', bgcolor: awayColor, borderRadius: 3 }} />
        </Box>
      </Box>
    </Box>
  );
}

export default function StatsCard({ stats, homeColor, awayColor }) {
  return (
    <Paper sx={{ p: 2, bgcolor: 'background.paper' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
        <EqualizerRounded sx={{ color: 'text.secondary', fontSize: 18 }} />
        <Typography variant="subtitle2" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
          Stats
        </Typography>
      </Box>
      <Divider sx={{ mb: 1.5, borderColor: 'divider' }} />
      {stats.map((stat, i) => (
        <StatBar key={i} stat={stat} homeColor={homeColor} awayColor={awayColor} />
      ))}
    </Paper>
  );
}
